import { c as _c } from "react/compiler-runtime";
import { type ChainId, ChainUtils } from '@morpho-org/blue-sdk';
import { InterfaceChainUtils } from '@morpho-org/dapp-core';
import { useMemo } from 'react';
import { toInterfaceInputToken } from '@/helpers/interfaceToken';
import { getVaultUrl } from '@/helpers/routing';
import type { MarketTransactionsTableRow } from '../config/MarketTransactions.types';
import type { MarketTransaction } from '../transactions.contract';
import { MARKET_TRANSACTION_TYPE_LABELS, MARKET_TRANSACTION_TYPE_TO_LEGACY } from '../config';
export interface TransactionRows {
  transactions?: readonly MarketTransaction[];
  chainId: ChainId;
}
const useTableTransactionRow = t0 => {
  const $ = _c(4);
  const {
    transactions,
    chainId
  } = t0;
  let t1;
  bb0: {
    if (!transactions) {
      let t2;
      if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = [];
        $[0] = t2;
      } else {
        t2 = $[0];
      }
      t1 = t2;
      break bb0;
    }
    let t2;
    if ($[1] !== chainId || $[2] !== transactions) {
      const identifier = InterfaceChainUtils.getIdentifierById(chainId);
      t2 = transactions.map(tx => {
        const vault = tx.vault?.name && tx.vault.asset ? {
          address: tx.vault.address,
          name: tx.vault.name,
          assetLogoUri: tx.vault.asset.logoUri,
          isV2: tx.vault.kind === "vaultV2"
        } : undefined;
        return {
          chainId,
          hash: tx.txHash,
          timestamp: BigInt(tx.timestamp),
          type: MARKET_TRANSACTION_TYPE_TO_LEGACY[tx.type],
          typeText: MARKET_TRANSACTION_TYPE_LABELS[tx.type],
          urlHash: ChainUtils.getExplorerTransactionUrl(chainId, tx.txHash),
          asset: toInterfaceInputToken(tx.asset, chainId),
          amount: tx.assets,
          amountUsd: tx.assetsUsd,
          user: {
            address: tx.userAddress
          },
          vault,
          vaultUrl: vault ? getVaultUrl({
            identifier,
            vaultAddress: vault.address,
            vaultName: vault.name
          }) : undefined
        };
      });
      $[1] = chainId;
      $[2] = transactions;
      $[3] = t2;
    } else {
      t2 = $[3];
    }
    t1 = t2;
  }
  return t1;
};
export default useTableTransactionRow;